module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-main",
    class: {
      'for-service': _vm.quesDetail.status === 1 && !_vm.quesDetail.doctorId, 'in-service': _vm.quesDetail.status === 1 && _vm.quesDetail.doctorId, 'out-of-service': _vm.quesDetail.status === 2, 'denial-of-service': _vm.quesDetail.status === 4
    },
    attrs: {
      "id": "detail-container"
    }
  }, [_c('div', {
    staticClass: "top-tips-box border2"
  }, [_vm._v("医生将在1小时内回答您的问题")]), _vm._v(" "), _c('div', {
    ref: "msgList",
    staticClass: "list-message-box",
    on: {
      "scroll": _vm.onListScroll,
      "touchstart": _vm.saveTouchY,
      "touchmove": _vm.computTouchY
    }
  }, [_c('ul', [_c('li', {
    staticClass: "msg-of-doctor"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.doctor && !_vm.hasHistoryMsg) ? _c('Doctor', {
    attrs: {
      "doctor": _vm.doctor,
      "type": 2,
      "id": _vm.quesDetail.doctorId,
      "transiton": "fade"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.listScroll.isLoading) ? _c('li', {
    staticClass: "msg-loading-box"
  }) : _vm._e(), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _vm._l((_vm.filterMessage(_vm.quesDetail.details)), function(item) {
    return _c('li', {
      staticClass: "msg-item"
    }, [_c('div', {
      staticClass: "msg-of-time"
    }, [_vm._v(_vm._s(_vm.dateFormat(item.msgTime)))]), _vm._v(" "), (item.content.type === 'audio') ? _c('div', {
      staticClass: "msg-content msg-of-audio",
      class: {
        'is-loading': _vm.audioObj.playId === item.id, 'is-playing': _vm.audioObj.isCanPlay && _vm.audioObj.playId === item.id
      }
    }, [_c('audio', {
      ref: "listaudio",
      refInFor: true,
      attrs: {
        "src": item.content.file,
        "preload": "auto"
      }
    }), _vm._v(" "), (item.type !== 1) ? _c('router-link', {
      staticClass: "msg-of-avatar",
      attrs: {
        "tag": "div",
        "to": '/doctor/' + _vm.quesDetail.doctorId + '?hideNav=1'
      }
    }, [(item.url) ? [_c('img', {
      attrs: {
        "src": item.url
      }
    })] : [(item.type === 2) ? _c('img', {
      attrs: {
        "src": require("./../assets/images/expert.png"),
        "data-track": "yy_djk_kwys_xqys"
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 3) ? _c('img', {
      attrs: {
        "src": require("./../assets/images/expert.png")
      }
    }) : _vm._e()]], 2) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "msg-of-detail"
    }, [_c('div', {
      staticClass: "msg-of-nickname"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "msg-of-content border3",
      on: {
        "click": function($event) {
          _vm.playAudio(item.id, $event)
        }
      }
    }, [_c('div', {
      staticClass: "media-wrap",
      style: ({
        'animation-duration': _vm.audioObj.duration + 's'
      })
    }), _vm._v(" "), _c('img', {
      staticClass: "loading-status",
      attrs: {
        "src": require("./../assets/images/audio-loading.gif")
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "to-play-status",
      attrs: {
        "src": require("./../assets/images/for-play@2x.png")
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "playing-status",
      attrs: {
        "src": require("./../assets/images/playing.gif")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "msg-of-time-show"
    }), _vm._v(" "), (item.readStatus !== 1) ? _c('div', {
      staticClass: "msg-of-unread"
    }) : _vm._e()])])], 1) : _c('div', {
      staticClass: "msg-content",
      class: {
        'msg-of-text': item.content.type === 'text', 'msg-of-img': item.content.type === 'image', 'position-right': item.type === 1, 'send-fail-status': item.sendStaus == '1'
      }
    }, [(item.type !== 1) ? _c('router-link', {
      staticClass: "msg-of-avatar",
      attrs: {
        "tag": "div",
        "to": '/doctor/' + _vm.quesDetail.doctorId + '?hideNav=1',
        "data-track": "yy_djk_kwys_xqys"
      }
    }, [(item.type === 2) ? [(item.url) ? _c('img', {
      attrs: {
        "src": item.url,
        "data-track": "yy_djk_kwys_xqys"
      }
    }) : _c('img', {
      attrs: {
        "src": require("./../assets/images/expert.png"),
        "data-track": "yy_djk_kwys_xqys"
      }
    })] : _vm._e(), _vm._v(" "), (item.type === 3) ? [(item.url) ? _c('img', {
      attrs: {
        "src": item.url
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 2) ? _c('img', {
      attrs: {
        "src": require("./../assets/images/expert.png")
      }
    }) : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "msg-of-detail"
    }, [_c('div', {
      staticClass: "msg-of-nickname"
    }, [_vm._v(_vm._s(item.name || '佚名'))]), _vm._v(" "), (item.content.type === 'text') ? _c('div', {
      staticClass: "msg-of-content"
    }, [_vm._v("\n                " + _vm._s(item.content.text) + "\n                "), (item.type === 1) ? _c('div', {
      staticClass: "btn-send",
      on: {
        "click": function($event) {
          _vm.sendAgain(item.id, $event)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.content.type === 'image') ? _c('div', {
      staticClass: "msg-of-content border3"
    }, [(item.content.file) ? _c('div', {
      staticClass: "preview-img"
    }, [_c('img', {
      staticClass: "preview-img",
      attrs: {
        "src": item.type === 1 ? item.content.smallUrl : item.content.file,
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.preview(item.id)
        }
      }
    })]) : _c('img', {
      attrs: {
        "src": require("./../assets/images/placeholder.png"),
        "alt": ""
      }
    }), _vm._v(" "), (item.type === 1) ? _c('div', {
      staticClass: "btn-send",
      on: {
        "click": function($event) {
          _vm.sendAgain(item.id, $event)
        }
      }
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (item.type === 1) ? _c('div', {
      staticClass: "msg-of-avatar"
    }, [(item.url) ? _c('img', {
      attrs: {
        "src": item.url
      }
    }) : _c('img', {
      attrs: {
        "src": require("./../assets/images/member.png")
      }
    })]) : _vm._e()], 1)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "bottom-toolbar-box border5"
  }, [_c('div', {
    staticClass: "base-input-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendMes),
      expression: "sendMes"
    }],
    staticClass: "base-input-area border1",
    attrs: {
      "rows": "1",
      "placeholder": "输入文字描述病情..."
    },
    domProps: {
      "value": (_vm.sendMes)
    },
    on: {
      "focus": _vm.onInputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sendMes = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "file-input-wrap needsclick",
    attrs: {
      "data-track": "yy_djk_kwys_xqtpsc"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.chooseImageCmd($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "send-msg-cmd",
    class: {
      disabled: _vm.isSend
    },
    attrs: {
      "disabled": _vm.isSend,
      "data-track": "yy_djk_kwys_xqfs"
    },
    on: {
      "click": _vm.onSendTextCmd
    }
  }, [_vm._v("发送")]), _vm._v(" "), _c('form', {
    staticClass: "hidden-form",
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    ref: "inputFile",
    staticClass: "needsclick",
    attrs: {
      "type": "file",
      "id": "file-input-placeholder",
      "accept": "image/*",
      "name": "image",
      "multiple": "multiple"
    },
    on: {
      "change": _vm.fileUploadChange
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "question-end-box border5"
  }, [_c('div', {
    staticClass: "question-end-tips"
  }, [_vm._v("问题已自动关闭")]), _vm._v(" "), _c('div', {
    staticClass: "question-end-opt"
  }, [(_vm.quesDetail.commentStatus === 0) ? _c('router-link', {
    attrs: {
      "tag": "button",
      "to": {
        path: '/rate/' + _vm.interrogationid + '/' + _vm.quesDetail.doctorId + '/' + '?hideNav=1'
      },
      "data-track": "yy_djk_kwys_pj"
    }
  }, [_vm._v("\n        去评价\n      ")]) : _c('button', {
    staticClass: "disabled-btn"
  }, [_vm._v("已评价")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "button",
      "to": {
        path: '/question?hideNav=1'
      },
      "data-track": "yy_djk_kwys_tzwqtwt"
    }
  }, [_vm._v("再问其他问题")])], 1)]), _vm._v(" "), (_vm.isShowOptMask) ? _c('div', {
    staticClass: "opt-mask",
    on: {
      "touchstart": _vm.onHideOptMask
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "msg-of-tips"
  }, [_c('p', [_vm._v("医生的回复仅为建议，具体诊疗请前往医院进行")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aeb585a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Detail.vue
// module id = 610
// module chunks = 1